const messages = {
  pt: {
    translations: {
      'full': 'Completa',
      'remote': 'Remota',
      'expertise': 'Perícia',
      'days': 'dias',
      'all': 'Todos',
      'regular': 'Regulares',
      'irregular': 'Irregulares',
      'notifications': 'Notificações',
      'view all notifications': 'Ver todas as notificações',
      header: {
        'message': 'Bem vindo de volta',
        'logout': 'Sair',
        'edit profile': 'Editar Perfil'
      },
      menu: {
        'home': 'Inicio',
        'processes': 'Processos',
        'financial control': 'Controle financeiro',
        'analytical report': 'Relatório analítico',
        'outher modules': 'Outros módulos',
        'settings': 'Configurações',
        'faq': 'Perguntas frequentes',
        'request support': 'Solicitar suporte',
        'new process': 'Nova O.S.',
        'complete your profile': 'Complete seu perfil',
        'score': 'Pontos',
        'financial': 'Assinatura'
      },
      home: {
        'total processes': 'Total de processos',
        'processes completed': 'Processos finalizados',
        'processes in progress': 'Processos em andamento',
        'total completed': 'Total finalizadas',
        'average execution time': 'Tempo médio de execução',
        'processes': 'Processos',
        'compared to (0 previous month)': 'Comparado a (0 mês anterior)',
      },
      support: {
        'need help?': 'Precisa de ajuda?',
        'contact our support team through the contacts below': 'Entre em contato com nosso time de suporte através dos contatos abaixo',
        'click here': 'Clique aqui'
      },
      processes: {
        'search': 'Pesquisar',
        'export': 'Exportar',
        'selected': 'Selecionados',
        'sinister': 'Sinistro',
        'date': 'Data',
        'provider': 'Prestador',
        'well insured': 'Bem segurado',
        'regularity': 'Regularidade',
        'in progress': 'Em andamento',
        'completed': 'Finalizado',
        'to edit': 'Editar',
        'report': 'Relato'
      },
      edit: {
        'process steps': 'Etapas do processo',
        'registry': 'Registro',
        'files': 'Arquivos',
        'social networks': 'Redes sociais',
        'interviews': 'Entrevistas',
        'local search': 'Pesquisa local/croqui',
        'public agencies': 'Orgãos públicos',
        'conclused': 'Conclusão',
        'finish': 'Finalizar',
        'to save': 'Salvar',
        'expenses': 'Despesas',
      }
    }
  }
}


export { messages }
